import type { Property } from '@/types';

export const additionalProperties: Property[] = [
  {
    id: 'kt-0302',
    title: 'Kirana Two - Low Zone Podium Commercial',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-0302',
    floor: 3,
    zone: 'Low Zone',
    condition: 'Fully Fitted',
    type: 'For Rent',
    category: 'Low Zone Commercial',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 160,
    area: '160 m²',
    price: 'IDR 28.8 Juta / bulan',
    numericPrice: 28800000,
    rentalRateSqm: 180000,
    serviceChargeSqm: 50000,
    ceilingHeight: '3.00 m',
    electricityCapacity: '22 kVA',
    parkingRatio: '1 : 80 m²',
    viewType: 'Main Plaza & Drop-off View',
    image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Akses Langsung Escalator dari Banking Hall',
      'Pencahayaan Alami Maksimal dengan Window Wall Side',
      'Cocok untuk Kantor Cabang, Clinic, atau Advisory Firm'
    ],
    description: 'Unit komersial podium di lantai 3 dengan akses mudah dari lobby utama dan area parkir gedung. Cocok untuk kantor layanan publik, consultan, maupun back-office modern.',
    featured: false,
  },
  {
    id: 'kt-3801',
    title: 'Kirana Two - Penthouse Sky Suite & Helipad Access',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-3801',
    floor: 38,
    zone: 'Penthouse',
    condition: 'Fully Fitted',
    type: 'For Rent',
    category: 'Penthouse Executive',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 520,
    area: '520 m²',
    price: 'IDR 145.6 Juta / bulan',
    numericPrice: 145600000,
    rentalRateSqm: 280000,
    serviceChargeSqm: 70000,
    ceilingHeight: '3.50 m Executive Height',
    electricityCapacity: '66 kVA',
    parkingRatio: '1 : 40 m²',
    viewType: 'Skyline Unobstructed 270° View',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1541888946425-d0fbb186a5b3?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Lift Privat Khusus CEO & Tamu VIP',
      'Private Outdoor Sky Garden Terrace',
      'Ruang Lounge VIP dengan Bar & Dining Table',
      'Akses Langsung ke Helipad Gedung'
    ],
    description: 'Unit Penthouse teratas di Kirana Two Office Tower. Didesain khusus untuk jajaran direksi, C-level executive, dan headquarter korporasi multinasional dengan standar keamanan dan fasilitas eksklusif teratas.',
    featured: false,
  },
  {
    id: 'kt-0905',
    title: 'Kirana Two - Serviced Office Plug & Play Hub',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-0905',
    floor: 9,
    zone: 'Low Zone',
    condition: 'Serviced Office',
    type: 'For Rent',
    category: 'Serviced Office',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 85,
    area: '85 m²',
    price: 'IDR 21.2 Juta / bulan',
    numericPrice: 21250000,
    rentalRateSqm: 250000,
    serviceChargeSqm: 0,
    ceilingHeight: '2.80 m',
    electricityCapacity: '16 kVA',
    parkingRatio: '1 : 100 m²',
    viewType: 'East Boulevard View',
    image: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Sudah Termasuk Biaya Service Charge & Listrik',
      'Layanan Resepsionis & Penerimaan Surat/Dokumen',
      'Fasilitas Ruang Rapat Gratis 10 Jam / bulan',
      'High-Speed Internet 1Gbps Dedicated'
    ],
    description: 'Solusi siap pakai (plug-and-play) untuk tim berisi 12-18 orang. Tanpa repot mengurus biaya operasional tambahan.',
    featured: false,
  },
  {
    id: 'kt-2102',
    title: 'Kirana Two - Financial & Legal Suite',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-2102',
    floor: 21,
    zone: 'Mid Zone',
    condition: 'Fully Fitted',
    type: 'For Rent',
    category: 'Mid Zone Suite',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 310,
    area: '310 m²',
    price: 'IDR 65.1 Juta / bulan',
    numericPrice: 65100000,
    rentalRateSqm: 210000,
    serviceChargeSqm: 55000,
    ceilingHeight: '2.85 m',
    electricityCapacity: '40 kVA',
    parkingRatio: '1 : 100 m²',
    viewType: 'West City View',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Ruang Arsip Khusus dengan Pintu Besi Berpengaman',
      '3 Ruang Kerja Manajerial Terpisah',
      'Carpet Tile Acoustic Grade A'
    ],
    description: 'Unit perkantoran di lantai 21 yang dirancang khusus untuk kantor hukum, akuntan publik, atau firma investasi.',
    featured: false,
  },
  {
    id: 'kt-2508',
    title: 'Kirana Two - Panoramic High Zone Suite',
    towerName: 'Kirana Two Office Tower',
    unitCode: 'KT-2508',
    floor: 25,
    zone: 'High Zone',
    condition: 'Bare Shell',
    type: 'For Sale',
    category: 'High Zone Suite',
    location: 'Jl. Boulevard Timur No. 88, Kelapa Gading, Jakarta Utara',
    sizeSqm: 450,
    area: '450 m²',
    price: 'IDR 13.5 Milyar (Strata Title)',
    numericPrice: 13500000000,
    rentalRateSqm: 0,
    serviceChargeSqm: 60000,
    ceilingHeight: '3.00 m',
    electricityCapacity: '50 kVA',
    parkingRatio: '1 : 80 m²',
    viewType: 'North & East Open View',
    image: 'https://images.unsplash.com/photo-1541888946425-d0fbb186a5b3?auto=format&fit=crop&w=1200&q=80',
    galleryImages: [
      'https://images.unsplash.com/photo-1541888946425-d0fbb186a5b3?auto=format&fit=crop&w=1200&q=80'
    ],
    floorPlanImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    features: [
      'Strata Title Hak Milik',
      'Pemandangan Lepas Tanpa Terhalang Gedung Lain',
      'Koneksi Pipa Chilled Water untuk AC Central Gedung'
    ],
    description: 'Investasi properti komersial yang menguntungkan di lantai 25 Kirana Two Office Tower. Status kepemilikan Strata Title.',
    featured: false,
  }
];
